import gql from 'graphql-tag';

export const GET_PRODUCT_CATEGORIES = gql`
	query getProductCategories(
    $search: String
    $pagination: PaginationAttributes
) {
    items: productCategories(search: $search, pagination: $pagination) {
      id
      name
      amountProducts
    }
  }
`;
